import { ActionReducer, Action } from '@ngrx/store';

export function clearStateMetaReducer(reducer: ActionReducer<any>): ActionReducer<any> {
    return function(state: any, action: Action) {
        if (action.type === '[Auth] Logout User') {
            // Setting state to undefined resets the store to its initial state
            state = undefined;
        }
        return reducer(state, action);
    };
}